import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { sandboxApi } from "services/sandbox-api/api";
import { useAppDispatch } from "store";
import { sandboxActionCompleted } from "store/features";
import { Button, Dialog, Icon, ModalButtonBar, ModalContent } from "@itwin/itwinui-react";
import styles from "./DeleteSandboxActionHandler.module.css";
import { SvgStatusWarning } from "@itwin/itwinui-icons-react";
import { LoadingSpinner } from "components/loading-spinner/LoadingSpinner";

interface DeleteSandboxActionHandlerProps {
  sandboxId?: string;
  userId?: string;
  redirect?: string;
}

export const DeleteSandboxActionHandler = ({ sandboxId: codeshareId, userId, redirect }: DeleteSandboxActionHandlerProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [deleteSandbox, { isLoading }] = sandboxApi.useCodeShareDeleteMutation();
  const [confirmed, setConfirmed] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const onConfirm = () => {
    if (codeshareId && userId) {
      deleteSandbox({ userId, codeshareId });
      setConfirmed(true);
    }
  }

  const onClose = () => {
    setIsModalOpen(false);
    setTimeout(() => dispatch(sandboxActionCompleted()), 200);
  };

  useEffect(() => {
    setTimeout(() => setIsModalOpen(true), 5);
  }, []);

  useEffect(() => {
    if (confirmed && !isLoading && redirect) {
      onClose();
      navigate(redirect);
    }
  }, [isLoading, confirmed]);

  return (
    <Dialog isOpen={isModalOpen} onClose={onClose} closeOnEsc closeOnExternalClick preventDocumentScroll trapFocus setFocus isDismissible>
      <Dialog.Backdrop />
      <Dialog.Main className={styles.deleteDialog} data-testid="atp-delete-sandbox-dialog">
        <Dialog.TitleBar titleText="Delete Sandbox" />
        <ModalContent className={styles.content}>
          <Icon fill="warning" size="large" >
            <SvgStatusWarning />
          </Icon>
          <p>
            Would you like to delete this sandbox? This action is not reversible.
          </p>
        </ModalContent>
        <ModalButtonBar>
          {isLoading && <LoadingSpinner centered hPos="left" size="small" message="Deleting..." />}
          <Button styleType="high-visibility" onClick={onConfirm} data-testid="atp-delete-sandbox-btn">Delete</Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalButtonBar>
      </Dialog.Main>
    </Dialog>
  )
};
